import * as React from "react";
import { EmailLink } from "../EmailLink";

/**
 * Enantis email link properties.
 */
export interface IEnantisEmailLinkProps {
  /** Email to Enantis. */
  email?: string;
  /** Subject to include to mailto link. */
  subject?: string;
  /** Tool name to create subject (applied if `subject` is not defined). */
  toolName?: string;
}

/**
 * Email link to Enantis with optional subject based on tool name or given directly.
 */
export function EnantisEmailLink(props: IEnantisEmailLinkProps) {
  const email = props.email ?? "enantis@enantis.com";
  const subject = props.subject
    ? props.subject
    : props.toolName
      ? `${props.toolName}: commercial use`
      : undefined;
  return <EmailLink email={email} subject={subject}/>;
}
